/* =================== DETALHE PRODUTO =================== */
jQuery(document).ready(function ($) {
  var cont = $("#cont-fotos li").length;
  var bolinha = cont > 1 ? true : false;

  // Carrosel fotos
  $(".produto-detalhe-fotos-destaque").slick({
    slidesToShow: 1,
    infinite: false,
    dots: bolinha,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: false,
    fade: true,
    //asNavFor: ".produto-detalhe-fotos-thumbs",
    responsive: [
      {
        breakpoint: 480,
        settings: {
          dots: false,
          arrows: false,
        },
      },
    ],
  });

  // Carrosel thumbs
  $(".produto-detalhe-fotos-thumbs").slick({
    slidesToShow: 4,
    infinite: false,
    slidesToScroll: 1,
    focusOnSelect: true,
    arrows: false,
    asNavFor: ".produto-detalhe-fotos-destaque",
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });

  /* Tipos de venda */
  function mudaTipoVenda(tipo){
    $('input[name=rolo-metro]').removeAttr('checked');
    $('input[name=rolo-inteiro]').removeAttr('checked');
    $('.valor-atual').html(formataMoeda($('.valor-inicial').val()));
    $('.comprimento-selecionado').val('');
    $('.por small').show();
    $('#variacao_id').val('');
    if(tipo.data('tipo') == "m2"){
      $('.rolos-medidas').show();
      $('.rolos-inteiros').hide();
      $('input[name=variacao]').val('m2');
    } else if(tipo.data('tipo') == "rolo_inteiro"){
      $('.rolos-medidas').hide();
      $('.rolos-inteiros').show();
      $('input[name=variacao]').val('rolo_inteiro');
    }
  }
  $('.muda_tipo_venda').on('click', function(e){
    mudaTipoVenda($(this));
  });
  $('input[name=rolo-metro]').removeAttr('checked');
  $('input[name=rolo-inteiro]').removeAttr('checked');
  

  /* Valor e tipo da venda */
  /* inteiro */
  $('.opcao-rolo-inteiro').on('click', function(){
    var m2 = $(this).data('comprimento')*$(this).data('largura');
    $('.valor-atual').html(formataMoeda($(this).data('valor')*m2));
    $('.por small').hide();
    $('#variacao_id').val($(this).val());
  });

  /* m2 */
  function calculaPorMetro(comprimento){
    var multiplo = 5;
    if (comprimento.val() % multiplo === 0) {
      var m2 = comprimento.val()*$('input[name=rolo-metro]:checked').data('largura');
      $('.valor-atual').html(formataMoeda($('input[name=rolo-metro]:checked').data('valor')*m2));
      $('.por small').hide();
      $('#variacao_id').val($('input[name=rolo-metro]:checked').val());
    }else{
      showAlert("Erro", "Comprimento, sempre considere múltiplos de 5 metros (Ex: 5, 10, 15, 20...).", "error");
      mudaTipoVenda();
    }
  }
  $('.comprimento-selecionado').on('change', function(){
    calculaPorMetro($('.comprimento-selecionado'));
  });
  $('input[name=rolo-metro]').on('change', function(){
    if($('.comprimento-selecionado').val() > 0){
      calculaPorMetro($('.comprimento-selecionado'));
    }
  });





});
